import { useWalletConnection } from "../../utility/useWalletConnection";
import chooseNetwork from "../../assets/img/choose-network.png";

//TODO: Testnet testleri tamamlandıktan sonra network seçim ve izinleri ayarlanacak
const ChooseNetwork = () => {
  const { open } = useWalletConnection();

  return (
    <div
      className="choose-network"
      style={{ cursor: "pointer" }}
      title="Choose Network"
    >
      <img
        onClick={() => open({ view: "Networks" })}
        className="w-100"
        src={chooseNetwork}
        alt="choose network"
      />
    </div>
  );
};

export default ChooseNetwork;
